import React from 'react';

const VideoFrame = ({ 
  videoUrl, 
  title = "Video", 
  aspectRatio = "16:9",
  logoPosition = "bottom-right" 
}) => {
  // Convert aspect ratio to padding percentage
  const getPaddingBottom = () => {
    if (aspectRatio === "16:9") return "56.25%";
    if (aspectRatio === "9:16") return "177.78%"; // For shorts
    if (aspectRatio === "4:3") return "75%";
    return "56.25%"; // Default to 16:9
  };

  return (
    <div className="video-frame-container">
      <div className="video-frame-border">
        <div className="video-frame-inner">
          <div 
            className="video-responsive" 
            style={{ paddingBottom: getPaddingBottom() }}
          >
            <iframe
              src={videoUrl}
              title={title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="video-iframe"
            />
          </div>
        </div>
        
        {/* Logo Overlay */}
        <div className={`video-frame-logo ${logoPosition}`}>
          <img 
            src="/praise-iam-logo.png" 
            alt="Praise I AM Apologetics" 
            className="video-logo-img"
          />
        </div>
      </div>
    </div>
  );
};

export default VideoFrame;
